import { httpPost } from "utils/httpRequest"

const listStartResource = async ({ pageNo, pageSize, dataType, dataTitle }) => {
  const resp = await httpPost("admin/startResource/list", {
    pageNo,
    pageSize,
    dataType,
    dataTitle,
  })

  return resp.data
}

const buildStartResourcePayload = ({ dataType, dataId, isHome, id, tierAccess, tierExclusive }) => {
  const payload = { dataType, dataId, isHome, id }
  const normalizedTier = typeof tierAccess === "string" ? tierAccess.trim() : tierAccess
  if (normalizedTier) {
    payload.tierAccess = normalizedTier
    payload.tierExclusive = Boolean(tierExclusive)
  }
  return payload
}

const addStartResource = async (params) => {
  const resp = await httpPost("admin/startResource/add", buildStartResourcePayload(params))

  return resp.data
}

const editStartResource = async (params) => {
  const resp = await httpPost("admin/startResource/edit", buildStartResourcePayload(params))
  return resp.data
}

const deleteStartResource = async ({ id }) => {
  const resp = await httpPost("admin/startResource/delete", {
    id,
  })
  return resp.data
}

const exchangeStartResourceIndex = async (updateIndexArray) => {
  const resp = await httpPost("admin/startResource/exchangeIndex", {
    updateIndexArray,
  })
  return resp.data
}

export {
  listStartResource,
  addStartResource,
  editStartResource,
  deleteStartResource,
  exchangeStartResourceIndex,
}
